import React from "react";
import UserIcon from "../../../assets/Images/user1.png";
import NameIcon from "../../../assets/Images/name-icon.png";
import AddressIcon from "../../../assets/Images/address-icon.png";
import DateIcon from "../../../assets/Images/date.png";
import PhoneIcon from "../../../assets/Images/phone.png";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import FiberPinIcon from "@mui/icons-material/FiberPin";

import { FieldSchema } from "../components/GenericForm";

/** Helper to render image icons */
const renderIcon = (src: string, alt: string): React.ReactNode => (
  <img src={src} alt={alt} className="imgs" style={{ width: 24, height: 24 }} />
);

/** Signup Form Schema */
export const signupFormSchema: FieldSchema[] = [
  {
    type: "text",
    name: "user_name",
    label: "Username",
    icon: renderIcon(UserIcon, "Username"),
    required: true,
  },
  {
    type: "text",
    name: "name",
    label: "Name",
    icon: renderIcon(NameIcon, "Name"),
  },
  {
    type: "text",
    name: "organization_name",
    label: "Organization name",
    icon: renderIcon(AddressIcon, "Organization name"),
    required: true,
  },
  {
    type: "text",
    name: "org_Arabic_Name",
    label: "Organization arabic name",
    icon: renderIcon(AddressIcon, "Org arabic name"),
  },
  { type: "businessType", name: "business_type", label: "Business Type" },
  {
    type: "email",
    name: "email_id",
    label: "Email",
    icon: <MailOutlineIcon />,
    required: true,
  },
  {
    type: "date",
    name: "date_of_birth",
    label: "Date of Birth (dd-mm-yyyy)",
    icon: renderIcon(DateIcon, "Date"),
    grid: { xs: 12, sm: 6 },
  },
  {
    type: "tel",
    name: "phone_number",
    label: "Phone number",
    icon: renderIcon(PhoneIcon, "Phone"),
    grid: { xs: 12, sm: 6 },
  },
  {
    type: "text",
    name: "address_line_1",
    label: "Address",
    icon: renderIcon(AddressIcon, "Address"),
  },
  {
    type: "text",
    name: "business_location",
    label: "Business Location",
    icon: renderIcon(AddressIcon, "Business Location"),
  },
  { type: "timeZone", name: "time_zone_id", label: "Time Zone" },
  { type: "countryState", name: "country_state", label: "Country/State" },
  {
    type: "number",
    name: "postal_code",
    label: "Postal code",
    icon: <FiberPinIcon />,
  },
];
